module.exports = __webpack_public_path__ + "img/logo.73096dcc.png";